import { GearStudioDesign, GearstudioProduct, GearstudioProductPanel } from "@src/types";

export const RANDOM_PROMPTS = [
    "Modern racing look with sharp geometric stripes in red and charcoal",
    "Minimal premium design in black, white, and metallic silver accents",
    "Aggressive cyber style with neon orange highlights over a dark base",
    "Classic retro sports stripes with cream, navy, and faded red tones",
    "Tactical camo with earthy tones and subtle distressed texture",
    "High-energy gradient blend with diagonal motion streaks and bold contrast",
];

export const STYLE_VARIATION_SUFFIXES = [
    "",
    " - variation: bold and high contrast",
    " - variation: soft and detailed",
    " - variation: creative and artistic",
];

export const DESIGN_INTERACTION_TOOLTIP =
    "Use one finger to rotate. Use two fingers to zoom and pan. On desktop, drag to rotate, scroll to zoom, and right click or shift-drag to pan.";

export const normalizeDesigns = (payload: unknown): GearStudioDesign[] => {
    if (Array.isArray(payload)) {
        return payload as GearStudioDesign[];
    }

    if (!payload || typeof payload !== "object") {
        return [];
    }

    const normalizedPayload = payload as { data?: unknown; results?: unknown };
    if (Array.isArray(normalizedPayload.data)) {
        return normalizedPayload.data as GearStudioDesign[];
    }

    if (Array.isArray(normalizedPayload.results)) {
        return normalizedPayload.results as GearStudioDesign[];
    }

    return [];
};

export const formatCreatedAt = (
    createdAt: GearStudioDesign["created_at"] | undefined,
    includeTime = true,
) => {
    if (!createdAt) {
        return "";
    }

    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return includeTime ? date.toLocaleString() : date.toLocaleDateString();
};

export const getTemplatePanels = (
    template: GearstudioProduct | null,
): GearstudioProductPanel[] => {
    if (!template) {
        return [];
    }

    return template.materials.map((panel) => ({
        id: panel.id,
        position: panel.position,
        name: panel.name,
    }));
};

export const pickRandomPrompt = () => {
    const randomIndex = Math.floor(Math.random() * RANDOM_PROMPTS.length);
    return RANDOM_PROMPTS[randomIndex];
};
